const CATEGORY = 'Video'

export const video = track => ({
    video: {
        error(error) {
            track(CATEGORY, 'Error', error)
        },

        qualityChange(targetQuality) {
            track(CATEGORY, 'Ganti kualitas video', targetQuality)
        },

        seek(targetTime) {
            track(CATEGORY, 'Seek', targetTime)
        },

        play() {
            track(CATEGORY, 'Putar')
        },

        pause() {
            track(CATEGORY, 'Jeda')
        },

        volume(targetVolume) {
            track(CATEGORY, 'Volume', targetVolume)
        },

        fullscreen() {
            track(CATEGORY, 'Fullscren')
        },

        pip() {
            track(CATEGORY, 'Picture in picture')
        },

        airplay() {
            track(CATEGORY, 'Airplay')
        },

        speed(targetSpeed) {
            track(CATEGORY, 'Kecepatan', targetSpeed)
        },
    }
})
